import { CompanyNewMemberAction } from '@/components/header/actions'
import { withNamespaces } from '@/i18n/route-namespaces'

const importMemberForm = () => import('@/pages/company/members/form')

export const membersRoutes = {
  path: 'members',
  lazy: withNamespaces(['members'], async () => {
    const { CompanyMembersContainer } = await import('@/pages/company/members')

    return { Component: CompanyMembersContainer }
  }),
  children: [
    {
      index: true,
      lazy: withNamespaces(['companies', 'members'], async () => {
        const { CompanyMembersList } = await import(
          '@/pages/company/members/list'
        )

        return { Component: CompanyMembersList }
      }),
      handle: {
        title: 'members.text',
        action: <CompanyNewMemberAction />,
      },
    },
    {
      path: 'add',
      lazy: withNamespaces(['companies', 'members'], async () => {
        const { CompanyMemberFormPage } = await importMemberForm()

        return { Component: CompanyMemberFormPage }
      }),
    },
    {
      path: 'edit',
      lazy: withNamespaces(['companies', 'members'], async () => {
        const { CompanyMemberFormPage } = await importMemberForm()

        return { Component: CompanyMemberFormPage }
      }),
    },
  ],
}
